class CashMovementEventController extends AbstractEntityEditController
	@register()
	@inject 'CashMovementEventsRepository',
		'UserInformation'
		'translate'
		'ToastService'
		'BACKEND_CASH_MOVEMENT_EVENT_ENTITY_TYPE'

	initialize: ->
		@filterDTO = new FilterDTO({
			pageSize: @CashMovementEventsRepository.getPageSize()
			itemsCount: 0
			sortProperty: 'timestamp'
		})

		@eventTypes = [
			{
				id: @BACKEND_CASH_MOVEMENT_EVENT_ENTITY_TYPE.WITHDRAWAL
				name: @translate('general.cash_movement_event.withdrawal')
			}
			{
				id: @BACKEND_CASH_MOVEMENT_EVENT_ENTITY_TYPE.DEPOSIT
				name: @translate('general.cash_movement_event.deposit')
			}
		]

		@masterUser = @UserInformation.getMasterUser()

	search: ->
		query = @filterDTO.getQuery()
		query.with('user', 'register', 'reason')

		@CashMovementEventsRepository
			.getEntities(query)
			.then (response) =>
				@cashMovementEvents = response

				for event in @cashMovementEvents
					event.isExpanded = false
					matchedType = _.find(@eventTypes, (item) -> item.id == event.entity_type)
					event.type = matchedType?.name

				@filterDTO.itemsCount = @cashMovementEvents.length

	getQuery: ->
		return @CashMovementEventsRepository.createQuery()

	getUserName: (event) ->
		return event.user?.full_name || @masterUser.email

	getUserId: (event) ->
		return event.user_id || @masterUser.id
